<h1>重要事項説明</h1> 
<mat-card class="cur-card">
    <app-sgkb106d-important-matter></app-sgkb106d-important-matter>
    <div class="tw-flex tw-flex-col tw-box-border tw-justify-center tw-items-end tw-content-end">
        <div class="tw-flex tw-flex-row tw-flex-wrap place-content-around">
            <mat-card-actions class="btn_area_right">
                <button type="button" mat-raised-button color="primary"  (click)="onClose()" class="btn">閉じる</button>
            </mat-card-actions>
        </div>
    </div>
</mat-card>